import { useContext } from "react";

import { resetStyle } from "../utils/styles";
import { Context } from "../context";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CommonHead from "./CommonHead";

const Layout = ({ children }) => {
  const { theme } = useContext(Context);

  return (
    <>
      <style jsx global>
        {resetStyle}
      </style>
      <style jsx global>{`
        body {
          color: ${theme.primaryTextColor};
          background-color: ${theme.backgroundColor};
        }
      `}</style>
      <CommonHead />
      <Navbar />
      <div className="page">{children}</div>
      <Footer />
      
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2933500308486888"
          crossOrigin="anonymous"
        ></script>
    </>
  );
};

export default Layout;
